import { render, staticRenderFns } from "./modalSaleadminAction.vue?vue&type=template&id=58c7af23&scoped=true"
import script from "./modalSaleadminAction.vue?vue&type=script&lang=js"
export * from "./modalSaleadminAction.vue?vue&type=script&lang=js"
import style0 from "./modalSaleadminAction.vue?vue&type=style&index=0&id=58c7af23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7af23",
  null
  
)

export default component.exports